import { HoneycombThemeBase, TypographyVariant } from '../types';
import {
    TypographyBodySize,
    TypographyFamily,
    TypographyFamilyProps,
    TypographyHeadingSize,
    TypographyHeroSize,
    TypographyPriceSize,
    TypographySizeProps,
} from '../types/HoneycombTypography';

export function getTypographyVariant(theme: HoneycombThemeBase) {
    return (value: TypographyVariant): TypographyFamilyProps & TypographySizeProps => {
        const { typography } = theme;
        const [family, size] = value.split('.');
        const familyProps = typography.family[family as TypographyFamily];
        let sizeProps;

        switch (family) {
            case 'heading':
                sizeProps = typography.variant.heading[size as TypographyHeadingSize].l;
                break;
            case 'hero':
                sizeProps = typography.variant.hero[size as TypographyHeroSize].l;
                break;
            case 'price':
                sizeProps = typography.variant.price[size as TypographyPriceSize].l;
                break;
            default:
                // body
                sizeProps = typography.variant.body[size as TypographyBodySize].l;
                break;
        }
        return { ...familyProps, ...sizeProps };
    };
}
